export type OrderStatus = 'Processing' | 'En Route' | 'Delivered' | 'Cancelled'
export type PaymentStatus = 'Pending' | 'Paid' | 'Failed' | 'Refunded'
export type OrderCategory = 'Agbada' | 'Kaftan' | 'Suits' | 'Traditional' | 'Accessories'
export type DatePreset = 'past24h' | 'week' | 'month' | 'year'
export type DateMode = 'preset' | 'between' | 'none'

export interface FilterState {
  status: string
  payment: string
  category: string
  dateMode: DateMode
  datePreset?: DatePreset
  dateRange?: { start: Date; end: Date }
  selectedDates: Date[]
}

export interface FilterOption {
  title: string
  value: string
}

export const STATUS_OPTIONS: FilterOption[] = [
  { title: "All Status", value: "All Status" },
  { title: "Order Received", value: "ORDER_RECEIVED" },
  { title: "Order Confirmed", value: "ORDER_CONFIRMED" },
  { title: "Processing", value: "PROCESSING" },
  { title: "En Route", value: "EN_ROUTE" },
  { title: "Delivered", value: "DELIVERED" },
  { title: "Cancelled", value: "CANCELLED" },
  { title: "Refunded", value: "REFUNDED" },
  { title: "Transfer Failed", value: "TRANSFER_FAILED" },
  { title: "Returned", value: "RETURNED" },
];

export const PAYMENT_OPTIONS: FilterOption[] = [
  { title: "All Payments", value: "All Payments" },
  // { title: 'Paid', value: 'Paid' },
  // { title: 'Pending', value: 'PENDING' },
  { title: "Refunded", value: "REFUNDED" },
  { title: "Failed", value: "TRANSFER_FAILED" },
];

export const CATEGORY_OPTIONS: FilterOption[] = [
  { title: 'All Categories', value: 'All Categories' },
  { title: 'Agbada', value: 'Agbada' },
  { title: 'Kaftan', value: 'Kaftan' },
  { title: 'Suits', value: 'Suits' },
  { title: 'Casuals', value: 'Casuals' },
  // { title: 'Accessories', value: 'Accessories' }
]

export const DATE_PRESET_OPTIONS: FilterOption[] = [
  { title: 'Date', value: 'Date' },
  { title: 'Past 24hours', value: 'past24h' },
  { title: 'Past week', value: 'week' },
  { title: 'Past month', value: 'month' },
  { title: 'Past year', value: 'year' },
  { title: 'Between dates', value: 'between' }
]

export const DEFAULT_FILTER_STATE: FilterState = {
  status: 'All Status',
  payment: 'All Payments',
  category: 'All Categories',
  dateMode: 'none',
  selectedDates: []
}